export enum AutoAdvanceMode {
    ByBlock,
    Enabled,
    Disabled,
}
